module.exports = {
	"name": "extreme-pingpong-tournament",
	"version": "0.2.0",
	"description": "Extreme Pingpong tournament",
	"license": "MIT",
	"private": true,
	"author": "Pedro Gutiérrez <info@xitrus.es> (http://xitrus.es)",
	"homepage": "extreme-pingpong.xitrus.es",
	"repository": {
		"type": "git",
		"url": "https://github.com/Pedro-vk/extreme-pingpong-tournament"
	},
	"scripts": {
		"ng": "ng",
		"start": "ng serve",
		"prebuild": "npm run clean",
		"build": "ng build --aot --sourcemap --prod",
		"postbuild": "npm run cache",
		"test": "ng test --single-run --code-coverage",
		"lint": "ng lint",
		"e2e": "ng e2e",
		"clean": "rm -rf ./dist/",
		"cache": "sw-precache --config=src/sw-precache.config.js --root=dist",
		"create-cname": "echo $(cat package.json | grep '\"homepage\"' | cut -d '\"' -f 4) > dist/CNAME",
		"heroku": "cp -fr ./.heroku/. ./dist",
		"gh-pages-travis": "npm run create-cname && npm run heroku && gh-pages-travis"
	},
	"dependencies": {
		"@angular/common": ">=4.0.0-beta <5.0.0",
		"@angular/compiler": ">=4.0.0-beta <5.0.0",
		"@angular/core": ">=4.0.0-beta <5.0.0",
		"@angular/forms": ">=4.0.0-beta <5.0.0",
		"@angular/http": ">=4.0.0-beta <5.0.0",
		"@angular/platform-browser": ">=4.0.0-beta <5.0.0",
		"@angular/platform-browser-dynamic": ">=4.0.0-beta <5.0.0",
		"@angular/router": ">=4.0.0-beta <5.0.0",
		"@ngrx/core": "^1.2.0",
		"@ngrx/store": "^2.2.1",
		"@ngrx/store-devtools": "^3.2.3",
		"core-js": "^2.4.1",
		"ngrx-store-freeze": "^0.1.9",
		"ngrx-store-localstorage": "^0.1.5",
		"reselect": "^3.0.0",
		"rxjs": "^5.1.0",
		"zone.js": "^0.8.4"
	},
	"devDependencies": {
		"@angular/cli": "^1.0.0",
		"@angular/compiler-cli": ">=4.0.0-beta <5.0.0",
		"@types/jasmine": "2.5.47",
		"@types/node": "~7.0.8",
		"codelyzer": "~3.0.0-beta.3",
		"gh-pages-travis": "^1.0.4",
		"jasmine-core": "~2.5.2",
		"jasmine-spec-reporter": "~4.0.0",
		"karma": "~1.6.0",
		"karma-chrome-launcher": "~2.0.0",
		"karma-cli": "~1.0.1",
		"karma-coverage-istanbul-reporter": "^1.0.0",
		"karma-coveralls": "^1.1.2",
		"karma-jasmine": "~1.1.0",
		"karma-jasmine-html-reporter": "^0.2.2",
		"karma-phantomjs-launcher": "1.0.4",
		"phantomjs": "^2.1.7",
		"protractor": "~5.1.0",
		"sw-precache": "^5.1.0",
		"ts-node": "~3.0.2",
		"tslint": "~5.1.0",
		"typescript": "~2.2.1"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 7YgM
// module chunks = 1